import api from './api';

const FRONTEND_UX_EVENT_TYPE = 'frontend_ux_first_action';

const normalizeElapsedMs = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed < 0) return 0;
  return Math.min(Math.round(parsed), 600000);
};

export const frontendTelemetryService = {
  async trackDevicesFirstAction(detail = {}) {
    const payload = {
      eventType: FRONTEND_UX_EVENT_TYPE,
      route: '/devices',
      action: detail.action || 'unknown',
      elapsedMs: normalizeElapsedMs(detail.elapsedMs),
      metadata: {
        timestamp: new Date().toISOString(),
      },
    };

    await api.post('/events/frontend-ux', payload);
  },
};

export default frontendTelemetryService;
